var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons8-edit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.748,
    height: 15.748,
    viewBox: "0 0 15.748 15.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13436",
    "data-name": "Path 13436",
    d: "M12.2,5.9,3,15.1v3.315H6.315l9.2-9.2Z",
    transform: "translate(-3 -2.667)",
    fill: "#533ffb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13437",
    "data-name": "Path 13437",
    d: "M15.6,3.989,17.589,2,20.9,5.315,18.915,7.3Z",
    transform: "translate(-5.156 -2)",
    fill: "#533ffb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenIcon);
export default __webpack_public_path__ + "static/media/pen-icon.3ad2e293e3bbdf57dac508b56bad4965.svg";
export { ForwardRef as ReactComponent };